// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__zuUbc","title":"style__title__YD3Rx","description":"style__description__HeIhE","component":"style__component__8ZH4d"};